




import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzChip extends Vue {
  @Prop({ type: String, default: "accent" }) tone!:
    | "accent"
    | "plain"
    | "ok"
    | "warn"
    | "error"
    | "neutral";
}
